module.exports = __webpack_public_path__ + "static/media/classification15.880e0152.jpg";